<template>
<footer class="footer" style=" background-color: black; display: block; height: 50px; width: 100%;">
    <center style="padding-top: 10px;">
    <!-- <img src="assets/anu.png">  -->
    <a
        href="https://www.instagram.com/anu.ab_/"><span>Copyright &copy; FIXIT</span>
        </a>
        </center>
  </footer>
</template>

<style scoped>
span{
color: white;
}
</style>